'use strict';

define('vb/action/builtin/logoutAction',[
  'vb/action/action',
],
(Action) => {
  /** @typedef {import('vb/action/action').Outcome} Outcome */

  /**
   * Launch the logout process as defined in the Security Provider implementation.
   * It invokes the handleLogout function on the Security Provider with the logoutUrl
   * argument.
   *
   * @param {String} logoutUrl the URL to navigate to in order to log out
   *
   * Returns a 'failure' outcome in case of error or the outcome 'success' with the payload true if
   * navigation to the login page was successful.
   *
   * @extends Action
   * @category Action
   */
  class LogoutAction extends Action {
    /**
     * Performs the logout action by invoking the handleLogout function on the Security Provider.
     *
     * @param {Object} [parameters] - The parameters object containing the logout URL.
     * @param {string} [parameters.logoutUrl] - The URL to navigate to in order to log out.
     *
     * @returns {Outcome} An outcome object indicating the result of the logout operation.
     *                   Returns a failure outcome in case of error or a success outcome with a payload of true
     *                   if navigation to the login page was successful.
     *
     * @throws {Error} If an error occurs during the logout operation.
     */
    perform(parameters) {
      const securityProvider = this.context.application.securityProvider;

      if (!securityProvider) {
        return Action.createFailureOutcome('Security Provider missing.');
      }

      try {
        securityProvider.handleLogout(parameters && parameters.logoutUrl);
        return Action.createSuccessOutcome();
      } catch (error) {
        return Action.createFailureOutcome('Error during logout operation', error);
      }
    }

    /**
     * Sets the context for the LogoutAction instance.
     *
     * @param {Object} context - The context object containing application-specific information.
     * @returns {void}
     */
    setContext(context) {
      this.context = context;
    }
  }

  return LogoutAction;
});

